export const pageSizes: PageSize[] = [10, 25, 50, 100]
export type PageSize = 10 | 25 | 50 | 100
